module.exports = __webpack_public_path__ + "static/media/stop.a608eb97.svg";